export default __webpack_public_path__ + "images/57_thumbnail.jpg";